import React, { useEffect, useRef, useState } from "react";
import {
  getDayDiffBetweenFiscalMonths,
  getDaysInFYMonths,
  secondsToHHMM,
  timeToSeconds,
  timeToSeconds2,
} from "../../../../Utilitie";
import {
  afYearlyTHead,
  ahWiseTHead,
  remarkTableHeader,
  sectionWiseThead,
} from "../AFHelper";
import DynamicTable from "../../../../Extra/DynamicTable";
import NoDataFound from "../../../../Extra/NoDataFound";
import { PiGreaterThan } from "react-icons/pi";
import { RiResetLeftFill } from "react-icons/ri";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const StationSectionWise = ({ data, more }) => {
  const coaSectionTable = useRef();
  const SectionTable = useRef();
  const nearYear = more.years[more?.years?.length - 1];
  const yearsData = data.filter((a) => a.F_YEAR === nearYear);
  const coaSection = [...new Set(yearsData.map((o) => o.COA_SECTION))];

  let months = [...new Set(yearsData.map((t) => t["A_MONTH"]))];
  let days = months.length > 1 ? getDaysInFYMonths(nearYear, months) : 1;
  const [filters, setFilters] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataForBs, setFilteredDataForBs] = useState([]);
  const blockSection = [
    ...new Set(filteredDataForBs?.map((o) => o.BLOCK_SECTION_STATION)),
  ];
  function filterData() {
    return data?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        return item[key] === value;
      });
    });
  }
  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      setFilteredData(filterData((data, filters)));
    } else {
      setFilteredData(data);
    }
  }, [filters, data]);
  useEffect(() => {
    if (filters.COA_SECTION) {
      const fd = yearsData.filter((f) => f.COA_SECTION === filters.COA_SECTION);
      setFilteredDataForBs(fd);
    } else setFilteredDataForBs(yearsData);
  }, [filters]);
  return (
    <div>
      <hr className="m-0 p-0" />
      <div className="row">
        <div className="col-md-12">
          <h4 className="bg-dark text-white p-1 ">
            Section Wise Asset Failure
          </h4>
        </div>
        <div className="row">
          {/* ////////////////////////COA SECTION  WISE TABLE////////////////////////// */}
          <div className="col-md-6">
            <h5 className="bg-dark text-white m-1 p-1">
              Section Wise{" "}
              <b style={{ color: "#d3d3d3ff", fontSize: "14px" }}>
                ({nearYear})
              </b>
            </h5>
            <div className="newUiBody table-responsive p-0">
              {yearsData.length > 0 ? (
                <div>
                  <div style={{ maxHeight: "400px", overflow: "auto" }}>
                    <table
                      className="table newUiTable table-hover table-striped mt-0 p-0"
                      ref={coaSectionTable}
                    >
                      <thead className="table-dark sticky-top ">
                        <tr>
                          <th>Sr</th>
                          {sectionWiseThead.map((head, i) => {
                            return <th key={i}> {head}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {coaSection &&
                          coaSection.map((coa, i) => {
                            let days = coaSection
                              ? getDaysInFYMonths(nearYear, months)
                              : 1;

                            return (
                              <tr
                                className={
                                  coa === filters.COA_SECTION &&
                                  `border border-primary table-primary`
                                }
                                style={{ cursor: "pointer" }}
                                key={i}
                                onClick={() => setFilters({ COA_SECTION: coa })}
                              >
                                <td>{i + 1}</td>
                                <td>{coa}</td>
                                <td>
                                  {yearsData.filter(
                                    (y) => y.COA_SECTION === coa,
                                  )?.length || 0}
                                </td>
                                <td>
                                  {(
                                    yearsData.filter(
                                      (y) => y.COA_SECTION === coa,
                                    )?.length / days
                                  ).toFixed(2) || 0}
                                </td>
                                <td>
                                  {secondsToHHMM(
                                    (
                                      yearsData
                                        .filter((y) => y.COA_SECTION === coa)
                                        .reduce((sum, obj) => {
                                          return (
                                            sum +
                                            obj.Average_Detention_Time_Mins_Total_20 *
                                              60
                                          );
                                        }, 0) / days
                                    ).toFixed(0),
                                  )}
                                </td>{" "}
                                <td>
                                  {secondsToHHMM(
                                    yearsData
                                      .filter((y) => y.COA_SECTION === coa)
                                      .reduce((sum, o) => {
                                        return (
                                          sum + timeToSeconds2(o["11DURATION"])
                                        );
                                      }, 0),
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {yearsData
                                    .filter((y) => y.COA_SECTION === coa)
                                    .reduce((sum, o) => {
                                      return (
                                        sum +
                                        Number(o.No_of_Trains_DelayedTotal_17)
                                      );
                                    }, 0)}
                                </td>
                                <td>
                                  {secondsToHHMM(
                                    yearsData
                                      .filter((y) => y.COA_SECTION === coa)
                                      .reduce((sum, obj) => {
                                        return (
                                          sum +
                                          obj.Average_Detention_Time_Mins_Total_20 *
                                            60
                                        );
                                      }, 0),
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                      <tfoot className=" table-dark sticky-bottom">
                        <tr>
                          {/* {console.log(yearsData)} */}
                          <td colSpan={2}>Total</td>
                          <td>{yearsData.length}</td>
                          <td> {(yearsData?.length / days).toFixed(2) || 0}</td>
                          <td>
                            {secondsToHHMM(
                              (
                                yearsData.reduce((sum, obj) => {
                                  return (
                                    sum +
                                    obj.Average_Detention_Time_Mins_Total_20 *
                                      60
                                  );
                                }, 0) / days
                              ).toFixed(0),
                            )}
                          </td>
                          <td>
                            {" "}
                            {secondsToHHMM(
                              yearsData.reduce((sum, o) => {
                                return sum + timeToSeconds2(o["11DURATION"]);
                              }, 0),
                            )}
                          </td>
                          <td>
                            {yearsData.reduce((sum, o) => {
                              return (
                                sum + Number(o.No_of_Trains_DelayedTotal_17)
                              );
                            }, 0)}
                          </td>
                          <td>
                            {secondsToHHMM(
                              yearsData.reduce((sum, obj) => {
                                return (
                                  sum +
                                  obj.Average_Detention_Time_Mins_Total_20 * 60
                                );
                              }, 0),
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <DownloadExcel
                    tableRef={coaSectionTable}
                    fileName={`AF Coa Section Wise `}
                  />
                </div>
              ) : (
                <NoDataFound />
              )}
            </div>
          </div>
          {/* //////////////////////// SECTION  WISE TABLE////////////////////////// */}
          <div className="col-md-6">
            <h5 className="bg-dark text-white m-1 p-1">
              Section /B-Section Wise{" "}
              <b style={{ color: "#d3d3d3ff", fontSize: "14px" }}>
                ({nearYear})
              </b>
            </h5>
            <div className="newUiBody table-responsive p-0">
              {yearsData.length > 0 ? (
                <div>
                  {}
                  <div style={{ maxHeight: "400px", overflow: "auto" }}>
                    <table
                      className="table newUiTable table-hover table-striped mt-0 p-0"
                      ref={SectionTable}
                    >
                      <thead className="table-dark sticky-top ">
                        <tr>
                          <th>Sr</th>
                          {sectionWiseThead.map((head, i) => {
                            return <th key={i}> {head}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {blockSection &&
                          blockSection.map((bs, i) => {
                            return (
                              <tr
                                className={
                                  bs === filters.BLOCK_SECTION_STATION &&
                                  `border border-primary table-primary`
                                }
                                style={{ cursor: "pointer" }}
                                key={i}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    BLOCK_SECTION_STATION: bs,
                                  })
                                }
                              >
                                <td>{i + 1}</td>
                                <td>{bs}</td>
                                <td>
                                  {filteredDataForBs.filter(
                                    (y) => y.BLOCK_SECTION_STATION === bs,
                                  )?.length || 0}
                                </td>
                                <td>
                                  {(
                                    filteredDataForBs.filter(
                                      (y) => y.BLOCK_SECTION_STATION === bs,
                                    )?.length / days
                                  ).toFixed(2) || 0}
                                </td>
                                <td>
                                  {secondsToHHMM(
                                    (
                                      filteredDataForBs
                                        .filter(
                                          (y) => y.BLOCK_SECTION_STATION === bs,
                                        )
                                        .reduce((sum, obj) => {
                                          return (
                                            sum +
                                            obj.Average_Detention_Time_Mins_Total_20 *
                                              60
                                          );
                                        }, 0) / days
                                    ).toFixed(0),
                                  )}
                                </td>{" "}
                                <td>
                                  {secondsToHHMM(
                                    filteredDataForBs
                                      .filter(
                                        (y) => y.BLOCK_SECTION_STATION === bs,
                                      )
                                      .reduce((sum, o) => {
                                        return (
                                          sum + timeToSeconds2(o["11DURATION"])
                                        );
                                      }, 0),
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {filteredDataForBs
                                    .filter(
                                      (y) => y.BLOCK_SECTION_STATION === bs,
                                    )
                                    .reduce((sum, obj) => {
                                      return (
                                        sum +
                                        Number(obj.No_of_Trains_DelayedTotal_17)
                                      );
                                    }, 0)}
                                </td>
                                <td>
                                  {secondsToHHMM(
                                    filteredDataForBs
                                      .filter(
                                        (y) => y.BLOCK_SECTION_STATION === bs,
                                      )
                                      .reduce((sum, obj) => {
                                        return (
                                          sum +
                                          obj.Average_Detention_Time_Mins_Total_20 *
                                            60
                                        );
                                      }, 0),
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                      <tfoot className=" table-dark sticky-bottom">
                        <tr>
                          <td colSpan={2}>Total</td>
                          <td>{filteredDataForBs.length}</td>
                          <td>
                            {" "}
                            {(filteredDataForBs?.length / days).toFixed(2) || 0}
                          </td>
                          <td>
                            {secondsToHHMM(
                              (
                                filteredDataForBs.reduce((sum, obj) => {
                                  return (
                                    sum +
                                    obj.Average_Detention_Time_Mins_Total_20 *
                                      60
                                  );
                                }, 0) / days
                              ).toFixed(0),
                            )}
                          </td>
                          <td>
                            {" "}
                            {secondsToHHMM(
                              filteredDataForBs.reduce((sum, o) => {
                                return sum + timeToSeconds2(o["11DURATION"]);
                              }, 0),
                            )}
                          </td>
                          <td>
                            {filteredDataForBs.reduce((sum, obj) => {
                              return (
                                sum + Number(obj.No_of_Trains_DelayedTotal_17)
                              );
                            }, 0)}
                          </td>
                          <td>
                            {secondsToHHMM(
                              filteredDataForBs.reduce((sum, obj) => {
                                return (
                                  sum +
                                  obj.Average_Detention_Time_Mins_Total_20 * 60
                                );
                              }, 0),
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <DownloadExcel
                    tableRef={SectionTable}
                    fileName={`AF Coa Section Wise `}
                  />
                </div>
              ) : (
                <NoDataFound />
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="row
      "
      >
        {filteredData && (
          <div>
            <div className="  bg-dark text-white pe-2 ps-2">
              {" "}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center ">
                  <h4>Failure Remarks for - </h4>
                  <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                    {Object.entries(filters).map(([key, value], i) => {
                      return i === 0 ? (
                        <h6 key={i}>{value}</h6>
                      ) : (
                        <h6 key={i}>
                          <PiGreaterThan />
                          {value}
                        </h6>
                      );
                    })}
                  </div>
                </div>
                <div>
                  {" "}
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => setFilters({})}
                  >
                    <RiResetLeftFill />
                  </button>
                </div>
              </div>
            </div>
            <DynamicTable
              data={filteredData}
              headers={remarkTableHeader}
              rowsPerPage={15}
              fontSize={"12px"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StationSectionWise;
